// extracted by mini-css-extract-plugin
export default {"rows":"tOmQ4Df590RFFEJ_ngjU","extraInfo":"CmpJ5JBk1ylii2nLvly7","item":"ae8_T4lNyKRSrqxsLvde"};